'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _throttle2 = require('lodash/throttle');

var _throttle3 = _interopRequireDefault(_throttle2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }



var _module = _angular2.default.module('cb.ui-components.progress-bar', []);

_module.component('cbProgressBar', {
    template: "<div class=\"progress-bar\">\r\n    <div class=\"progress-bar__indicator\">\r\n\r\n    </div>\r\n</div>\r\n",
    controller: ['$scope', function controller($scope) {
        var $ctrl = this;
        $ctrl.totalScroll = 0;
        var userScrolled = false;

        // Declare variables
        var body = document.getElementsByClassName('site')[0];
        var html = document.documentElement;
        var windowHeight = window.innerHeight;

        var eventHandler = function eventHandler() {
            var wintop = window.scrollY || window.pageYOffset;
            var bodyHeight = Math.max(body.scrollHeight, body.offsetHeight, html.scrollHeight, html.offsetHeight);
            $ctrl.totalScroll = calculateTotalScroll(wintop, bodyHeight, windowHeight);
            userScrolled = true;

            _angular2.default.element('.progress-bar__indicator').css('width', $ctrl.totalScroll + '%');
        };

        /** Listen to scroll events */
        _angular2.default.element(window).bind('scroll', (0, _throttle3.default)(eventListenerCallback, 100));

        function eventListenerCallback() {
            eventHandler();
        }
        /**
         * Calculates position of the window, relative to bodyheight
         *
         * @param wintop
         * @param bodyheight
         * @param windowheight
         * @returns {Number}
         */

        var calculateTotalScroll = function calculateTotalScroll(wintop, bodyheight, windowheight) {
            return wintop / (bodyheight - windowheight) * 100;
        };
    }]
});

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-progress-bar.component.js
// module id = 861
// module chunks = 0